var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetsGetStarted2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 90,
    viewBox: "0 0 88 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.542 9.25787C47.6462 9.25787 35.3569 0 26.7337 0C18.1105 0 0 4.95062 0 44.5685C0 84.1864 24.3638 90 33.8486 90C78.2634 90.0026 97.2355 9.25787 65.542 9.25787Z",
    fill: "#3CB4E5",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8907 19.5063L70.9775 17.4196L75.151 21.5931L73.0642 23.6798L68.8907 19.5063Z",
    fill: "#A4AFC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.887 31.5034L82.9737 29.4167L87.1472 33.5902L85.0604 35.6769L80.887 31.5034Z",
    fill: "#A4AFC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3727 21.6045L84.5462 17.431L86.6329 19.5178L82.4594 23.6912L80.3727 21.6045Z",
    fill: "#A4AFC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1952 71.5582C52.4564 71.5582 64.0173 59.9973 64.0173 45.7361C64.0173 31.475 52.4564 19.9141 38.1952 19.9141C23.9341 19.9141 12.3732 31.475 12.3732 45.7361C12.3732 59.9973 23.9341 71.5582 38.1952 71.5582Z",
    fill: "#F3F3F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2634 56.8037H27.1302C25.5012 56.8037 24.1791 55.4816 24.1791 53.8526V40.5727C24.1791 38.9437 25.5012 37.6216 27.1302 37.6216H49.2634C50.8924 37.6216 52.2145 38.9437 52.2145 40.5727V53.8526C52.2145 55.4816 50.8924 56.8037 49.2634 56.8037Z",
    fill: "#3CB4E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0131 45.7361C19.0131 32.6038 28.8255 21.7851 41.5152 20.1501C40.4263 20.0114 39.3226 19.9141 38.1952 19.9141C23.9326 19.9141 12.3732 31.4735 12.3732 45.7361C12.3732 59.9958 23.9326 71.5582 38.1952 71.5582C39.3226 71.5582 40.4263 71.4608 41.5152 71.3221C28.8255 69.6872 19.0131 58.8685 19.0131 45.7361Z",
    fill: "#D5DBE1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.819 53.8526V40.5727C30.819 38.9437 32.1411 37.6216 33.7701 37.6216H27.1302C25.5012 37.6216 24.1791 38.9437 24.1791 40.5727V53.8526C24.1791 55.4816 25.5012 56.8037 27.1302 56.8037H33.7701C32.1411 56.8037 30.819 55.4816 30.819 53.8526Z",
    fill: "#A5BCD2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1967 73.7725C22.7388 73.7725 10.1613 61.1949 10.1613 45.7371C10.1613 30.2792 22.7388 17.7017 38.1967 17.7017C53.6545 17.7017 66.2321 30.2792 66.2321 45.7371C66.2321 61.1949 53.6545 73.7725 38.1967 73.7725ZM38.1967 22.1283C25.1794 22.1283 14.5879 32.7198 14.5879 45.7371C14.5879 58.7543 25.1794 69.3458 38.1967 69.3458C51.2139 69.3458 61.8054 58.7543 61.8054 45.7371C61.8054 32.7198 51.2139 22.1283 38.1967 22.1283Z",
    fill: "#1E9BCF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8315 64.5156L56.9612 61.386L81.8835 86.3083L78.7539 89.438L53.8315 64.5156Z",
    fill: "#1E9BCF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7299 59.0168H27.0631C24.1466 59.0168 21.7742 56.6443 21.7742 53.7279V40.1278C21.7742 37.2113 24.1466 34.8389 27.0631 34.8389H49.7299C52.6464 34.8389 55.0188 37.2113 55.0188 40.1278V53.7279C55.0188 56.6443 52.6464 59.0168 49.7299 59.0168ZM27.0631 39.3722C26.646 39.3722 26.3075 39.7107 26.3075 40.1278V53.7279C26.3075 54.1449 26.646 54.4834 27.0631 54.4834H49.7299C50.147 54.4834 50.4855 54.1449 50.4855 53.7279V40.1278C50.4855 39.7107 50.147 39.3722 49.7299 39.3722H27.0631Z",
    fill: "#1E9BCF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5742 37.6218H41.1476V33.1952C41.1476 32.7879 40.817 32.4574 40.4098 32.4574H35.9831C35.5759 32.4574 35.2454 32.7879 35.2454 33.1952V37.6218H30.8187V33.1952C30.8187 30.3474 33.1353 28.0308 35.9831 28.0308H40.4098C43.2576 28.0308 45.5742 30.3474 45.5742 33.1952V37.6218Z",
    fill: "#1E9BCF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1792 44.2617H52.2146V48.6884H24.1792V44.2617Z",
    fill: "#1B8FBE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9812 41.311H40.4078V51.6399H35.9812V41.311Z",
    fill: "#1B8FBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsGetStarted2);
export default __webpack_public_path__ + "static/media/LetsGetStarted2.84a9b25e066ff16ada16b8388e781e36.svg";
export { ForwardRef as ReactComponent };